module.exports = __webpack_public_path__ + "img/meauicon6.0d83e600.svg";